import React from "react";
import { Cell, Row } from ".";
import { INITIAL_RISK_ASSESSMENT_COLORS } from "../constants";
import { INITIAL_RISK_WIDTHS } from "./table.utils";

export default function TableHeader() {
  return (
    <Row variant="header">
      <Cell style={{ width: INITIAL_RISK_WIDTHS.category }} variant="header">
        <strong>Category</strong>
      </Cell>
      <Cell style={{ width: INITIAL_RISK_WIDTHS.studySpecifics }} variant="header">
        <strong>Study Specifics</strong>
      </Cell>
      <Cell style={{ width: INITIAL_RISK_WIDTHS.riskScore }} variant="header">
        <strong>Risk Score</strong>
      </Cell>
      <Cell
        style={{
          width: INITIAL_RISK_WIDTHS.low,
          backgroundColor: INITIAL_RISK_ASSESSMENT_COLORS.GREEN,
        }}
        variant="header"
      >
        <strong>Low</strong>
      </Cell>
      <Cell
        style={{
          width: INITIAL_RISK_WIDTHS.moderate,
          backgroundColor: INITIAL_RISK_ASSESSMENT_COLORS.YELLOW,
        }}
        variant="header"
      >
        <strong>Moderate</strong>
      </Cell>
      <Cell
        style={{
          width: INITIAL_RISK_WIDTHS.high,
          backgroundColor: INITIAL_RISK_ASSESSMENT_COLORS.RED,
        }}
        variant="header"
      >
        <strong>High</strong>
      </Cell>
    </Row>
  );
}
